import {Route, Switch } from "react-router-dom";

import ExceptionPage from "../pages/ExceptionPage";
//import ResourceContainer from "../components/ResourcesContainer";
import ReportContainer from "../components/ReportContainer";
import DatasetContainer from "../components/dataset/DatasetContainer";

const Router = () => {
  return (
    <div>
      <Switch>
        <Route exact path="/" component={ReportContainer} />
        <Route exact path="/reports/:id" component={ReportContainer} />
        <Route exact path="/datasets/:id" component={DatasetContainer} />
        <Route render={(props) => <ExceptionPage {...props} status={404} />} />
      </Switch>
    </div>
  );
};
export default Router;
